<template>
  <div class="event-container">
    <span class="card-title" style="margin-bottom: 10px">Eventos</span>
    <div class="totals-container">
      <div class="totals-content" style="border: 1px solid #e6e9eb">
        <CustomSkeleton v-if="isLoadingAllData" type="line" width="100px" />
        <span v-if="!isLoadingAllData" class="totals-title">{{ events.length }} eventos</span>
        <span v-if="!isLoadingAllData" class="totals-subtitle">Realizados no período</span>
      </div>
      <div class="totals-content" style="border: 1px solid #e6e9eb">
        <CustomSkeleton v-if="isLoadingAllData" type="line" width="100px" />
        <span v-if="!isLoadingAllData" class="totals-title">{{ totalReviews() }}</span>
        <span v-if="!isLoadingAllData" class="totals-subtitle"
          >É a média de avaliações durante eventos no período.</span
        >
      </div>
    </div>
    <div class="calendar-wrapper">
      <div
        class="charts-two-blocks-container"
        style="flex-direction: column !important; margin-bottom: 10px; height: 100%"
      >
        <div class="visitors-number-container">
          <div class="chart-custom-header">
            <span class="card-title">Número de visitantes</span>
            <div v-if="!isLoadingAllData" style="display: flex">
              <div class="button-icon-chart" @click="createVisitantNumberChart('bar')">
                <i class="fa-solid fa-bars"></i>
              </div>
              <div class="button-icon-chart" @click="createVisitantNumberChart('line')">
                <i class="fa-solid fa-chart-line"></i>
              </div>
            </div>
          </div>
          <CustomSkeleton v-if="isLoadingAllData" type="card" />
          <canvas
            v-if="!isLoadingAllData"
            id="visitant-number-chart"
            class="visitant-number-chart"
          ></canvas>
        </div>
        <div class="impact-event-chart-container">
          <span class="card-title">Impacto de eventos nos setores</span>
          <div class="chart-custom-legend-container" style="margin: 10px 0">
            <CustomLegend color="#E7547B" text="Hospedagem" />
            <CustomLegend color="#6A6B93" text="Alimentação" />
            <CustomLegend color="#E135F0" text="Comércio" />
            <CustomLegend color="#324DDD" text="Transporte" />
          </div>
          <CustomSkeleton v-if="isLoadingAllData" type="card" />
          <canvas
            v-if="!isLoadingAllData"
            id="impact-event-chart"
            class="impact-event-chart"
          ></canvas>
        </div>
        <div class="hotel-occupancy-event-container">
          <div class="chart-custom-header">
            <span class="card-title">Ocupação hoteleira</span>
            <div v-if="!isLoadingAllData" style="display: flex">
              <div class="button-icon-chart" @click="createHotelOccupancyChart('bar')">
                <i class="fa-solid fa-bars"></i>
              </div>
              <div class="button-icon-chart" @click="createHotelOccupancyChart('line')">
                <i class="fa-solid fa-chart-line"></i>
              </div>
            </div>
          </div>
          <CustomSkeleton v-if="isLoadingAllData" type="card" />
          <canvas
            v-if="!isLoadingAllData"
            id="hotel-occupancy-chart"
            class="hotel-occupancy-chart"
          ></canvas>
        </div>
      </div>

      <div
        class="charts-two-blocks-container charts-two-blocks-calendar"
        style="
          flex-direction: column !important;
          align-items: flex-end !important;
          margin-bottom: 10px;
          margin-left: 10px;
        "
      >
        <CustomSkeleton v-if="isLoadingAllData" type="card" />
        <div v-if="!isLoadingAllData" class="calendar-container">
          <Calendar v-model="selectedInitDate" :inline="true" dateFormat="dd.mm.yy" locale="pt-BR">
            <template #date="slotProps">
              <div
                :class="{
                  'highlighted-date': isEventDate(slotProps.date),
                  'normal-date': !isEventDate(slotProps.date),
                }"
                v-if="isEventDate(slotProps.date)"
                v-tooltip="getEventTitles(slotProps.date)"
                @click="toggleHighlightEvent(slotProps.date)"
              >
                {{ slotProps.date.day }}
              </div>
              <div v-else class="normal-date">
                {{ slotProps.date.day }}
              </div>
            </template>
          </Calendar>
          <span class="card-title" style="margin: 25px 0">Listagem de eventos</span>
          <div
            class="card-event"
            v-for="event in events"
            :key="event.id"
            :ref="'event-' + event.id"
            @click="handleOpenEvent(event.link)"
          >
            <div class="card-header">
              <img :src="event.thumbnail" alt="" />
              <div class="card-subheader">
                <span class="event-name" v-tooltip="event.title">{{ event.title }}</span>
                <span class="event-date">{{ customFormatter(event.date) }}</span>
              </div>
            </div>
            <div class="card-body">
              <img src="/location-on-map.svg" alt="" /><span class="event-address">
                {{ event.address }}</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Calendar from 'primevue/calendar'
import Tooltip from 'primevue/tooltip'
import CustomLegend from '@/Shared/Charts/CustomLegend'
import CustomSkeleton from '@/Shared/CustomSkeleton.vue'
import moment from 'moment'
import { Chart, registerables } from 'chart.js'

Chart.register(...registerables)

export default {
  name: 'Event',
  components: {
    CustomSkeleton,
    CustomLegend,
    Calendar,
  },
  directives: {
    tooltip: Tooltip,
  },
  props: {
    events: {
      type: Array,
      required: true,
    },
    isLoadingAllData: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      selectedInitDate: new Date(),
      chart: null,
      chart2: null,
      chart3: null,
      highlightedEventId: null, // Adiciona uma propriedade para rastrear o evento destacado
    }
  },
  watch: {
    events: {
      immediate: true,
      handler() {
        if (!this.isLoadingAllData) {
          this.$nextTick(() => {
            this.createVisitantNumberChart()
            this.createImpactEventChart()
            this.createHotelOccupancyChart()
          })
        }
      },
    },
  },
  computed: {
    sortedEvents() {
      return [...this.events].sort((a, b) => new Date(a.date) - new Date(b.date))
    },
    eventsByDate() {
      const eventsMap = {}
      this.sortedEvents.forEach((event) => {
        const date = moment(event.date).format('YYYY-MM-DD')
        if (!eventsMap[date]) {
          eventsMap[date] = []
        }
        eventsMap[date].push(event.title)
      })
      return eventsMap
    },
  },
  methods: {
    customFormatter(date) {
      moment.locale('pt-br')
      return moment(date).format('DD/MM/YYYY')
    },
    handleOpenEvent(link) {
      window.open(link)
    },
    totalReviews() {
      const uniqueEvents = []
      const uniqueEventNames = new Set()
      this.sortedEvents.forEach((event) => {
        if (!uniqueEventNames.has(event.title)) {
          uniqueEvents.push(event)
          uniqueEventNames.add(event.title)
        }
      })
      const eventReviews = uniqueEvents.map((event) => event.venue.reviews)
      // Calcula a média de reviews
      const totalReviews = eventReviews.reduce((sum, reviews) => sum + reviews, 0)
      return (totalReviews / uniqueEvents.length).toFixed(0)
    },
    isEventDate(date) {
      const dateStr = `${date.year}-${String(date.month + 1).padStart(2, '0')}-${String(
        date.day,
      ).padStart(2, '0')}`
      return !!this.eventsByDate[dateStr]
    },
    getEventTitles(date) {
      const dateStr = `${date.year}-${String(date.month + 1).padStart(2, '0')}-${String(
        date.day,
      ).padStart(2, '0')}`
      return this.eventsByDate[dateStr] ? this.eventsByDate[dateStr].join(', ') : ''
    },
    getEventCount(date) {
      const dateStr = `${date.year}-${String(date.month + 1).padStart(2, '0')}-${String(
        date.day,
      ).padStart(2, '0')}`
      return this.eventsByDate[dateStr] ? this.eventsByDate[dateStr].length : 0
    },
    toggleHighlightEvent(date) {
      const dateStr = `${date.year}-${String(date.month + 1).padStart(2, '0')}-${String(
        date.day,
      ).padStart(2, '0')}`
      const events = this.sortedEvents.filter(
        (event) => moment(event.date).format('YYYY-MM-DD') === dateStr,
      )
      if (events.length > 0) {
        const eventId = events[0].id
        const elements = this.$refs['event-' + eventId]
        const element = Array.isArray(elements) ? elements[0] : elements
        if (element) {
          if (this.highlightedEventId === eventId) {
            element.classList.remove('highlight')
            this.highlightedEventId = null
          } else {
            if (this.highlightedEventId) {
              const prevElement = this.$refs['event-' + this.highlightedEventId]
              const prevEl = Array.isArray(prevElement) ? prevElement[0] : prevElement
              if (prevEl) {
                prevEl.classList.remove('highlight')
              }
            }
            element.classList.add('highlight')
            this.highlightedEventId = eventId
          }
        }
      }
    },
    createImpactEventChart() {
      const ctx = document.getElementById('impact-event-chart').getContext('2d')
      if (this.chart) {
        this.chart.destroy()
      }
      this.chart = new Chart(ctx, {
        type: 'line',
        data: {
          labels: ['Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb', 'Dom'],
          datasets: [
            {
              label: 'Hospedagem',
              data: [25, 20, 30, 40, 50, 160, 170],
              borderColor: '#E7547B',
              borderWidth: 3,
            },
            {
              label: 'Alimentação',
              data: [25, 20, 30, 40, 90, 180, 110],
              borderColor: '#6A6B93',
              borderWidth: 3,
            },
            {
              label: 'Comércio',
              data: [70, 80, 120, 130, 140, 170, 160],
              borderColor: '#E135F0',
              borderWidth: 3,
            },
            {
              label: 'Transporte',
              data: [50, 90, 180, 170, 160, 200, 190],
              borderColor: '#324DDD',
              borderWidth: 3,
            },
          ],
        },
        options: {
          responsive: true,
          spanGaps: true,
          elements: {
            line: {
              tension: 0.5,
            },
            point: {
              radius: 5,
              hoverRadius: 8,
              hitRadius: 10,
            },
          },
          scales: {
            y: {
              ticks: {
                callback: function (value) {
                  return 'R$' + value.toFixed(2)
                },
              },
            },
          },
          plugins: {
            legend: {
              display: false,
            },
          },
        },
      })
    },
    createVisitantNumberChart(chartType = 'bar') {
      const ctx = document.getElementById('visitant-number-chart').getContext('2d')
      if (this.chart2) {
        this.chart2.destroy()
      }
      const uniqueEvents = []
      const uniqueEventNames = new Set()

      this.sortedEvents.forEach((event) => {
        if (!uniqueEventNames.has(event.title)) {
          uniqueEvents.push(event)
          uniqueEventNames.add(event.title)
        }
      })

      const eventNames = uniqueEvents.map((event) => {
        const words = event.title.split(' ')
        const shortenedName = words.length > 3 ? words.slice(0, 3).join(' ') + '...' : event.title
        return {
          fullName: event.title,
          displayName: shortenedName,
        }
      })

      const eventReviews = uniqueEvents.map((event) => event.venue.reviews)

      this.chart2 = new Chart(ctx, {
        type: chartType,
        data: {
          labels: eventNames.map((event) => event.displayName),
          datasets: [
            {
              label: 'Número de Reviews',
              data: eventReviews,
              backgroundColor: 'rgba(30, 144, 255, 0.8)',
              barThickness: 30,
            },
          ],
        },
        options: {
          indexAxis: chartType === 'bar' ? 'y' : 'x',
          responsive: true,
          plugins: {
            legend: { display: false },
            title: { display: false },
            tooltip: {
              enabled: true,
              intersect: true,
              callbacks: {
                title: function (context) {
                  const event = eventNames[context[0].dataIndex]
                  return event.fullName
                },
                label: function (context) {
                  return `${context.raw} visitantes`
                },
              },
            },
          },
          interaction: {
            intersect: false,
          },
          scales: {
            x: {
              beginAtZero: true,
            },
          },
        },
      })
    },
    createHotelOccupancyChart(chartType = 'bar') {
      const ctx = document.getElementById('hotel-occupancy-chart').getContext('2d')
      if (this.chart3) {
        this.chart3.destroy()
      }
      const uniqueEvents = []
      const uniqueEventNames = new Set()

      this.sortedEvents.forEach((event) => {
        if (!uniqueEventNames.has(event.title)) {
          uniqueEvents.push(event)
          uniqueEventNames.add(event.title)
        }
      })

      const eventNames = uniqueEvents.map((event) => {
        const words = event.title.split(' ')
        const shortenedName = words.length > 3 ? words.slice(0, 3).join(' ') + '...' : event.title
        return {
          fullName: event.title,
          displayName: shortenedName,
        }
      })

      const eventReviews = uniqueEvents.map((event) => event.venue.reviews)

      this.chart3 = new Chart(ctx, {
        type: chartType,
        data: {
          labels: eventNames.map((event) => event.displayName),
          datasets: [
            {
              label: 'Número de Reviews',
              data: eventReviews,
              backgroundColor: '#7749F8',
              barThickness: 30,
            },
          ],
        },
        options: {
          indexAxis: chartType === 'bar' ? 'y' : 'x',
          responsive: true,
          plugins: {
            legend: { display: false },
            title: { display: false },
            tooltip: {
              enabled: true,
              intersect: true,
              callbacks: {
                title: function (context) {
                  const event = eventNames[context[0].dataIndex]
                  return event.fullName
                },
                label: function (context) {
                  return `${context.raw} visitantes`
                },
              },
            },
          },
          interaction: {
            intersect: false,
          },
          scales: {
            x: {
              beginAtZero: true,
            },
          },
        },
      })
    },
    handleTicketValueDays(id) {
      console.log('handleTicketValueDays')
    },
  },
}
</script>

<style src="./styles.css"></style>
